import { UseQueryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { useApi } from './useApi'

/**
 * Thin wrapper around `useApi` for the unified `/platform/device/data_fetcher` POST endpoint that
 * replaces the legacy Hasura queries. Wraps variables in the `{ path, payload }` envelope and
 * reuses `useApi`'s Auth0 accessToken auth — same token the other REST endpoints use.
 */
export const useDataFetcher = <TSchema extends z.ZodType>(
    path: string,
    payload: unknown,
    schema: TSchema,
    options: Omit<UseQueryOptions<z.infer<TSchema>, Error>, 'queryFn'>
) => useApi('/platform/device/data_fetcher', { path, payload: payload ?? {} }, schema, options)
